import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCourseStore } from '@/store/courseStore';
import { CourseDetail } from '@/components/course';
import { Breadcrumb, type BreadcrumbItem } from '@/components/common';
import SEOHead from '../components/common/SEOHead';

const CourseDetailPage = () => {
 // const { courseId } = useParams<{ courseId: string }>();
  const { hashId } = useParams<{ hashId: string }>();
  const {
    selectedCourse,
    loading,
    error,
    fetchCourseDetail,
    clearError
  } = useCourseStore();
/*
  useEffect(() => {
    if (courseId) {
      const id = parseInt(courseId, 10);
      if (!isNaN(id)) {
        fetchCourseDetail(id);
      }
    }
  }, [courseId, fetchCourseDetail]);

  // Registration is now handled internally by the CourseDetail component

  // Invalid course ID
  if (courseId && isNaN(parseInt(courseId, 10))) {
    return <Navigate to="/courses" replace />;
  }
*/
useEffect(() => {
  if (hashId) {
    fetchCourseDetail(hashId); // Gọi API theo slug thay vì id
  }
}, [hashId, fetchCourseDetail]);

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-m2-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-24 w-24 border-b-2 border-eh-forest-ink mx-auto"></div>
          <p className="mt-4 text-m2-on-surface-variant">Loading course details...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
       <div className="min-h-screen bg-m2-background flex items-center justify-center p-4">
        <div className="eh-panel eh-panel-cream text-center max-w-md p-8">
          <div className="mx-auto w-24 h-24 text-red-400 mb-4">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-full h-full">
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={1} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" 
              />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-m2-on-surface mb-2">Course not found</h3>
          <p className="text-m2-on-surface-variant mb-4">{error}</p>
          <div className="space-y-2">
            <button
              onClick={() => {
                clearError();
                if (hashId) {
                  fetchCourseDetail(hashId);
                }
              }}
              className="eh-btn"
            >
              Try Again
            </button>
            <div>
              <a href="/courses" className="text-m2-primary hover:text-m2-primary text-sm">
                ← Back to Courses
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // No course data
  if (!selectedCourse) {
    return (
      <div className="min-h-screen bg-m2-background flex items-center justify-center p-4">
        <div className="eh-panel eh-panel-cream text-center p-8">
          <p className="text-m2-on-surface-variant">Course not found</p>
          <a href="/courses" className="text-m2-primary hover:text-m2-primary">
            ← Back to Courses
          </a>
        </div>
      </div>
    );
  }

  // Build breadcrumb items
  const breadcrumbItems: BreadcrumbItem[] = [
    {
      name: 'Courses',
      href: '/courses'
    },
    {
      name: selectedCourse.name,
      current: true
    }
  ];

  return (
    <div className="bg-m2-background">
       <SEOHead
        title={selectedCourse.name || selectedCourse.name}
        description={selectedCourse.metadescription || selectedCourse.shortDescription}
        image={selectedCourse.openGraphImageUrl || selectedCourse.imageUrl}
        url={`/courses/${selectedCourse.slug ?? selectedCourse.id}`}
        type="website"
        noindex={false}
        tags={selectedCourse.tagNames}
        author={selectedCourse.lecturer || 'Chuyên gia của M2MBA'}
        publishedTime={new Date(selectedCourse.createdAt).toISOString()}
      />
      {/* Breadcrumb */}
      <div className="bg-m2-surface-lowest border-b border-m2-outline-variant">
        <div className="eh-container py-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </div>
      
      {/* Course Detail */}
      <CourseDetail 
        course={selectedCourse}
      />

    </div>
  );
};

export default CourseDetailPage